// extracted by mini-css-extract-plugin
module.exports = {"ledeImage":"ledeImage_ledeImage__nrpgq"};